/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-content[_ngcontent-%COMP%] {\n  background: #ffffff;\n  padding: 20px 40px;\n  border-radius: 10px;\n  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }\n\n.title[_ngcontent-%COMP%] {\n  margin: unset;\n  color: #4A4A4A; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-issue-form/document-issue-form.component.scss.shim.ngstyle.js.pre-build-optimizer.js